import { render, staticRenderFns } from "./ContentArticleForm.vue?vue&type=template&id=2d0beb36"
import script from "./ContentArticleForm.vue?vue&type=script&lang=js"
export * from "./ContentArticleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports